<template>
  <error-boundary module="employee-module">
    <component :is="moduleToRender" :slug="slug" :key="slug" />
  </error-boundary>
</template>

<script>
import store from '@/store';
import { COUNTRY } from '@/core/country';
import DocumentModule from '@/modules/document-module.vue';
import FormModule from '@/modules/form-module.vue';
import ErrorBoundary from "@/components/error-boundary.vue";

export default {
  name: 'EmployeeModule',
  components: { ErrorBoundary, DocumentModule, FormModule },
  props: {
    document: {
      type: String,
      default: null,
    },
    slug: {
      type: String,
      default: null,
    },
  },
  setup() {
    const moduleToRender =
      store.state.onboarding?.countryCode === COUNTRY.US
        ? FormModule
        : DocumentModule;

    return {
      moduleToRender,
    };
  },
};
</script>

<style scoped></style>
